export default __webpack_public_path__ + "static/media/femChef.6976a336.jpg";